import { IntlShape } from 'react-intl'
import { RegularEffect } from '../../../../typings'
import { create, enforce, omitWhen, test } from 'vest'
import { messages } from './messages'
import { benefitValidation } from './Benefit/Editor/validation'
import { scopeValidation } from './Scope/Editor/validation'

export function scopeSuite(intl: IntlShape, name: string) {
  const { $t } = intl

  return create((scope: RegularEffect['scope']) => {
    test(name, $t(messages.validation.emptyScope), () => {
      enforce(scope).isNotUndefined()
    })

    omitWhen(!scope, () => {
      test(name, $t(messages.validation.generic), () => {
        enforce(
          scopeValidation(intl, name)(scope!).isValidByGroup('scope')
        ).isTruthy()
      })
    })
  })
}

export function benefitSuite(intl: IntlShape, name: string) {
  const { $t } = intl

  return create((benefit: RegularEffect['benefit']) => {
    test(name, $t(messages.validation.emptyBenefit), () => {
      enforce(benefit).isNotUndefined()
    })

    omitWhen(!benefit, () => {
      test(name, $t(messages.validation.generic), () => {
        enforce(
          benefitValidation(intl)(benefit!).isValidByGroup('benefit')
        ).isTruthy()
      })
    })
  })
}
